<template>
  <div class="kanban-illustration">
    <div class="kanban-board-preview">
      <!-- Column 1: To Do -->
      <div class="preview-column">
        <div class="column-header">
          <span class="column-title">To Do</span>
          <span class="column-count">2</span>
        </div>
        <div class="preview-task-card">
          <div class="task-title">Patient Appointment</div>
          <div class="task-desc">Schedule follow-up for John Smith</div>
          <div class="task-tags">
            <span class="tag tag-priority-medium">Medium</span>
            <span class="tag tag-type">Appointment</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/14/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Sarah</span>
          </div>
        </div>
        <div class="preview-task-card">
          <div class="task-title">Insurance Verification</div>
          <div class="task-desc">Verify insurance for crown procedure</div>
          <div class="task-tags">
            <span class="tag tag-priority-high">High</span>
            <span class="tag tag-type">Admin</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/9/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Michael</span>
          </div>
        </div>
      </div>

      <!-- Column 2: In Progress -->
      <div class="preview-column">
        <div class="column-header">
          <span class="column-title">In Progress</span>
          <span class="column-count">2</span>
        </div>
        <div class="preview-task-card">
          <div class="task-title">Treatment Planning</div>
          <div class="task-desc">Plan Mrs. Johnson's rehabilitation</div>
          <div class="task-tags">
            <span class="tag tag-priority-high">High</span>
            <span class="tag tag-type">Treatment</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/11/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Dr. Williams</span>
          </div>
        </div>
        <div class="preview-task-card">
          <div class="task-title">Lab Work Submission</div>
          <div class="task-desc">Submit impressions for dentures</div>
          <div class="task-tags">
            <span class="tag tag-priority-medium">Medium</span>
            <span class="tag tag-type">Lab</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/10/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Dr. Chen</span>
          </div>
        </div>
      </div>

      <!-- Column 3: Review -->
      <div class="preview-column">
        <div class="column-header">
          <span class="column-title">Review</span>
          <span class="column-count">1</span>
        </div>
        <div class="preview-task-card">
          <div class="task-title">Patient Records Update</div>
          <div class="task-desc">Update records with treatment notes</div>
          <div class="task-tags">
            <span class="tag tag-priority-medium">Medium</span>
            <span class="tag tag-type">Admin</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/12/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Emma</span>
          </div>
        </div>
      </div>

      <!-- Column 4: Completed -->
      <div class="preview-column column-completed">
        <div class="column-header">
          <span class="column-title">Completed</span>
          <span class="column-count">1</span>
        </div>
        <div class="preview-task-card task-completed">
          <div class="task-title">Billing & Insurance Claims</div>
          <div class="task-desc">Process insurance claims for last week</div>
          <div class="task-tags">
            <span class="tag tag-priority-high">High</span>
            <span class="tag tag-type">Billing</span>
          </div>
          <div class="task-footer">
            <span class="task-date"><i class="fa fa-calendar-o"></i> 5/4/2025</span>
            <span class="task-assignee"><i class="fa fa-user-o"></i> Robert</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Caption -->
    <div class="illustration-caption" v-if="showCaption">
      <h3>{{ title || 'Organize Your Tasks Visually' }}</h3>
      <p>{{ description || 'Drag and drop tasks between columns to track progress and keep your team aligned.' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KanbanPreviewIllustration',
  props: {
    showCaption: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.kanban-illustration {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
}

.kanban-board-preview {
  display: flex;
  gap: 12px;
  padding: 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  overflow-x: auto;
  max-width: 100%;
}

.preview-column {
  min-width: 160px;
  max-width: 160px;
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  margin-bottom: 4px;
}

.column-title {
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.column-count {
  font-size: 10px;
  font-weight: 500;
  color: #94a3b8;
  background: #e2e8f0;
  padding: 2px 6px;
  border-radius: 8px;
}

.preview-task-card {
  background: white;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.preview-task-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.task-completed {
  opacity: 0.7;
}

.task-completed .task-title {
  text-decoration: line-through;
  color: #94a3b8;
}

.task-title {
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
  line-height: 1.3;
}

.task-desc {
  font-size: 9px;
  color: #64748b;
  margin-bottom: 6px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.task-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 6px;
}

.tag {
  font-size: 8px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 6px;
}

.tag-priority-high {
  background: #fee2e2;
  color: #dc2626;
}

.tag-priority-medium {
  background: #fef3c7;
  color: #d97706;
}

.tag-priority-low {
  background: #dcfce7;
  color: #16a34a;
}

.tag-type {
  background: #e0f2fe;
  color: #0284c7;
}

.task-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 8px;
  color: #94a3b8;
}

.task-date,
.task-assignee {
  display: flex;
  align-items: center;
  gap: 3px;
}

.task-date i,
.task-assignee i {
  font-size: 8px;
}

/* Caption Styles */
.illustration-caption {
  text-align: center;
  margin-top: 20px;
  max-width: 400px;
}

.illustration-caption h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}

.illustration-caption p {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Responsive */
@media (max-width: 700px) {
  .kanban-board-preview {
    padding: 12px;
  }

  .preview-column {
    min-width: 140px;
    max-width: 140px;
  }

  .task-title {
    font-size: 10px;
  }

  .task-desc {
    font-size: 8px;
  }
}

@media (max-width: 500px) {
  /* Hide the Review + Completed columns on phones — the 4-column layout
     overflows horizontally and the clipped right-edge column reads like
     a broken floating panel (users have mistaken it for the agent
     sidebar popping up). Two columns is plenty to convey the idea. */
  .preview-column:nth-child(3),
  .preview-column:nth-child(4) {
    display: none;
  }

  .preview-column {
    min-width: 130px;
    max-width: 130px;
  }
}
</style>
